"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var MerchantConfigurationClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(MerchantConfigurationClient, _BaseClient);

  function MerchantConfigurationClient(getAccessToken) {
    (0, _classCallCheck2["default"])(this, MerchantConfigurationClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MerchantConfigurationClient).call(this, getAccessToken, 'https://identity.financialflows.cimpress.io'));
  }

  (0, _createClass2["default"])(MerchantConfigurationClient, [{
    key: "getMerchantsUnderAccount",
    value: function () {
      var _getMerchantsUnderAccount = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(accountId) {
        var FILTER_VCS_REGEX, route, allMerchants, merchantsUnderAccount;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                FILTER_VCS_REGEX = '%5E(%3F!vcs-).*%24';
                route = "v1/merchants?hasAll=false&verbose=true&active=true&merchantIdFilter=".concat(FILTER_VCS_REGEX);
                _context.next = 4;
                return this.fetchWithAuth({
                  endpointUrl: this.endpointUrl,
                  route: route
                });

              case 4:
                allMerchants = _context.sent;
                merchantsUnderAccount = allMerchants.merchants.filter(function (merchant) {
                  return merchant.accountId === accountId;
                });
                return _context.abrupt("return", merchantsUnderAccount);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMerchantsUnderAccount(_x) {
        return _getMerchantsUnderAccount.apply(this, arguments);
      }

      return getMerchantsUnderAccount;
    }()
  }]);
  return MerchantConfigurationClient;
}(_BaseClient2["default"]);

exports["default"] = MerchantConfigurationClient;